import { TOOL_IDS, ToolIdType } from '@adsk/alloy-provider';

const { CHANGE_ORDER } = TOOL_IDS;

type GenDeepLinkUrlParams = {
  projectId: string;
  rfiId: string;
  currentToolId: ToolIdType | undefined;
};

export const genDeepLinkUrl = ({ projectId, rfiId, currentToolId }: GenDeepLinkUrlParams) => {
  const params = new URLSearchParams();

  params.set('preview', rfiId);
  if (currentToolId) {
    const isCurrentToolChangeOrder = currentToolId === CHANGE_ORDER;
    const origin = isCurrentToolChangeOrder ? 'pco' : currentToolId;
    params.set('origin', origin);
  }

  return `/build/rfis/projects/${projectId}/?${params.toString()}`;
};
